module.exports = __webpack_public_path__ + "models/100kb.4c6426a.txt";